import { render } from "./aboutOur.vue?vue&type=template&id=4b97c4b8&scoped=true"
import script from "./aboutOur.vue?vue&type=script&lang=js"
export * from "./aboutOur.vue?vue&type=script&lang=js"

import "./aboutOur.vue?vue&type=style&index=0&id=4b97c4b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b97c4b8"]])

export default __exports__